<template>
  <div class="stamp-container">
      <a href="https://miles-solutions.de/page/1" target="_blank">
      <template v-if="type === 'black'">
        <img v-if="original" src="https://logos.code-crew.de/original_seal/seal_black.png">
        <img v-else src="https://logos.code-crew.de/seal_black.png">
      </template>
      <template v-if="type === 'white'">
        <img v-if="original" src="https://logos.code-crew.de/original_seal/seal_white.png">
        <img v-else src="https://logos.code-crew.de/seal_white.png">
      </template>
      </a>
  </div>
</template>

<script>
export default {
	name: 'StampItem',
	props: {
		type: String,
		original: Boolean,
	},
};
</script>

<style src="@/styles/components/LogoItem/LogoItem.less" lang="less" scoped></style>
